import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const EvaluationContext = createContext();

export const EvaluationProvider = ({ children }) => {
  const [evaluatingStudent, setEvaluatingStudent] = useState(null);
  const [studentAnswers, setStudentAnswers] = useState(null);
  const [activeTabOverride, setActiveTabOverride] = useState(null);

  const startEvaluating = useCallback((student, answers = null) => {
    const enrichedStudent = answers ? { ...student, answers } : student;
    setEvaluatingStudent(enrichedStudent);
    if (answers) setStudentAnswers(answers);
    setActiveTabOverride('feedback');
  }, []);

  const stopEvaluating = useCallback(() => {
    setEvaluatingStudent(null);
    setStudentAnswers(null);
    setActiveTabOverride(null);
  }, []);

  const setTabOverride = useCallback((tabName) => {
    setActiveTabOverride(tabName);
  }, []);

  const updateStudentAnswers = useCallback((answers) => {
    setStudentAnswers(answers);
    if (evaluatingStudent) {
      setEvaluatingStudent({ ...evaluatingStudent, answers });
    }
  }, [evaluatingStudent]);

  const value = {
    evaluatingStudent,
    studentAnswers,
    startEvaluating,
    stopEvaluating,
    activeTabOverride,
    setTabOverride,
    updateStudentAnswers,
  };

  return (
    <EvaluationContext.Provider value={value}>
      {children}
    </EvaluationContext.Provider>
  );
};

EvaluationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useEvaluationContext = () => {
  const context = React.useContext(EvaluationContext);
  if (!context) {
    throw new Error('useEvaluationContext must be used within EvaluationProvider');
  }
  return context;
};

export default EvaluationContext;
